import {Navigate, useSearchParams} from 'react-router'

import {useGetPlantStructure} from '../common/hooks/queries/usePlantStructureQuery'

import {useGetPlantUpmId} from './hooks/upmEntityConfig/useGetPlantUpmId'

import {SettingsSkeleton} from '@settings/modules/common/components'
import {getUrl, PLANT_ROUTES, useUrlParam} from '@settings/modules/routing'

export const DefaultPlantNodeRedirect: React.FC = () => {
  const plantCode = useUrlParam('plantCode')
  const [searchParams] = useSearchParams()

  const {data: upmInfo} = useGetPlantUpmId()
  const {data: plantStructure} = useGetPlantStructure({
    includeEquipment: false,
    upmId: upmInfo?.upmId
  })

  if (!upmInfo || !plantStructure) {
    return <SettingsSkeleton />
  }

  const targetUrl = getUrl(PLANT_ROUTES.PLANT_SETUP.NODE.path, {
    plantCode,
    nodeId: plantStructure.upmId
  })
  
  const searchParamsString = searchParams.toString()
  const urlWithParams = searchParamsString ? `${targetUrl}?${searchParamsString}` : targetUrl

  return <Navigate to={urlWithParams} replace />
}
